import { ANALYSIS_SNAPSHOT_ZOOM } from '@common/constants/analysisExport'
import { CssVars } from './cssVars'

/** Query param the PDF export pipeline appends to the page it captures. */
export const SNAPSHOT_QUERY_PARAM = 'snapshot'

let snapshotRender: boolean | null = null

/**
 * Whether this document is being rendered by the export pipeline's headless
 * browser. The same question `useAnalysisSnapshotMode` answers, for the
 * formatting helpers — plain functions that cannot call a hook.
 *
 * Answered once and kept: the export renders one document in one mode, so a
 * later in-app navigation that drops the query param must not flip it
 * mid-render.
 */
export const isSnapshotRender = (): boolean => {
  if (snapshotRender === null) {
    snapshotRender =
      typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).get(SNAPSHOT_QUERY_PARAM) === 'true'
  }
  return snapshotRender
}

/**
 * The zoom an analysis page's root applies under `?snapshot=true` (`zoom: var(--snapshot-zoom)`).
 * Zooming the report rather than narrowing the viewport keeps the desktop media queries; the
 * report lays out in 1600 / zoom CSS px. Passed from here so it shares one constant with the
 * export's scale.
 */
export const SNAPSHOT_ROOT_VARS: CssVars = { '--snapshot-zoom': ANALYSIS_SNAPSHOT_ZOOM }
